import React, { useContext, useEffect, useRef, useState } from 'react'

import { TableContext } from './table/TableContext'
import FormsInProgress from './table/FormsInProgress'
import SubmittedForms from './table/SubmittedForms'
import { SimpleSpinner } from '../../elem/Spinner'
import NewUploadButton from './NewUploadButton'
import { DataContext } from './DataContext'
import BulkSubmitButton from './table/BulkSubmitButton'
import { useLocation } from 'react-router-dom'

const SubmissionTabs = ({ onChange, active }) => (
    <div className="tabs is-large">
        <ul>
            <li
                className={`${active === 'inProgress' ? 'is-active' : ''}`}
                onClick={() => onChange('inProgress')}
            >
                <span className="link">Forms In Progress</span>
            </li>
            <li
                className={`${active === 'submitted' ? 'is-active' : ''}`}
                onClick={() => onChange('submitted')}
            >
                <span className="link">Submitted Forms</span>
            </li>
        </ul>
        <NewUploadButton />
    </div>
)

export default () => {
    const { state: locationState } = useLocation()
    const topRef = useRef(null)
    const sectionRef = useRef(null)
    const [topHeight, setTopHeight] = useState(0)

    const { loading } = useContext(TableContext)
    const {
        initializeState,
        setActiveAgency,
        setFacilityID,
        setErrorState,
    } = useContext(DataContext)
    const [activeTab, setActiveTab] = useState('inProgress')

    useEffect(() => {
        setActiveAgency(null)
        initializeState({})
        setFacilityID(null)
        setErrorState({})
        setActiveTab(
            locationState && locationState.from
                ? locationState.from
                : 'inProgress'
        )
    }, [])

    // Measure the top section height and update on resize
    useEffect(() => {
        const updateHeight = () => {
            if (topRef.current) {
                const height = topRef.current.getBoundingClientRect().height
                setTopHeight(height)
            }
        }

        updateHeight()

        const resizeObserver = new ResizeObserver(updateHeight)

        if (topRef.current) {
            resizeObserver.observe(topRef.current)
        }

        window.addEventListener('resize', updateHeight)

        return () => {
            resizeObserver.disconnect()
            window.removeEventListener('resize', updateHeight)
        }
    }, [])

    useEffect(() => {
        if (sectionRef.current) {
            //2.3rem is navbar-height in variables.scss
            sectionRef.current.style.maxHeight = `calc(100vh - ${topHeight}px - 2.3rem)`
        }
    }, [topHeight])

    return (
        <div className="container uploads">
            <div ref={topRef}>
                <SubmissionTabs onChange={setActiveTab} active={activeTab} />
                <div className="bulkSubmitWrapper">
                    <BulkSubmitButton visible={activeTab === 'inProgress'} />
                </div>
            </div>

            <div ref={sectionRef}>
                {loading ? (
                    <SimpleSpinner />
                ) : activeTab === 'inProgress' ? (
                    <div key="inProgress" style={{ maxHeight: 'inherit', overflow: 'auto' }}>
                        <FormsInProgress />
                    </div>
                ) : (
                    <div key="submitted" style={{ maxHeight: 'inherit', overflow: 'auto' }}>
                        <SubmittedForms />
                    </div>
                )}
            </div>
        </div>
    )
}
